import { LeagueRepository } from '../repositories';

export class DeleteLeagueUseCase {
  constructor(private leagueRepository: LeagueRepository) {}

  async execute(leagueId: string): Promise<void> {
    await this.leagueRepository.delete(leagueId);
  }
}
